import { render, staticRenderFns } from "./PlacesReport.vue?vue&type=template&id=bcd9c858&"
import script from "./PlacesReport.vue?vue&type=script&lang=js&"
export * from "./PlacesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports